import { baseApi, handleQueryError } from "./baseApi";
import { axiosInstance } from "./utils";

export interface ClusterConfig {
  validateDataClassification?: boolean;
  [key: string]: unknown;
}

export const clusterApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getClusterConfig: builder.query<ClusterConfig, void>({
      queryFn: async () => {
        try {
          const response =
            await axiosInstance.get<ClusterConfig>(`/v1/cluster_config`);
          return { data: response.data };
        } catch (error) {
          return handleQueryError(error);
        }
      },
    }),
  }),
});

export const { useGetClusterConfigQuery } = clusterApi;
